
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as carto17Hk3H3NYEO_45FFdaJOjgwf0g_fC_a17YdUdJaFSiRYMeta } from "/vercel/path0/pages/cart.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as termsrbl0AisEJEK94jgNDoimMHDtED_45cqOs4QSX5phnU96AMeta } from "/vercel/path0/pages/terms.vue?macro=true";
import { default as logouta5LfroDscl83QSOVnBg1WHUyENO_v5V_454taSGE0odUIMeta } from "/vercel/path0/pages/logout.vue?macro=true";
import { default as cookieskQzajfkWpUwL4hsw6pnkYWspPKQxuurAoVdErGewAvUMeta } from "/vercel/path0/pages/cookies.vue?macro=true";
import { default as privacyoUxJze_459YVMN19fHCMNcOPA4bNg1TjmwARd6j9aojjEMeta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as profileFId_45d62DZvDfSRqu_45gOkgT1Y2dyc04X7CB8OOqCLklMMeta } from "/vercel/path0/pages/profile.vue?macro=true";
import { default as checkoutCVHKVPUd1E_45TOH8c9_4542gIRCznC3qyQFx_45Zk6UX36UgMeta } from "/vercel/path0/pages/checkout.vue?macro=true";
import { default as contactsGlPsXOYtjZxL2wpMVHpUc0wnHYJZPKr_XGyMnGh1f7kMeta } from "/vercel/path0/pages/contacts.vue?macro=true";
import { default as deliveryHJh7a_kGxpqzdtaXzQIyqOt_kkUfDaC_dip1qKEmDtAMeta } from "/vercel/path0/pages/delivery.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as wishlistCXO9iynX3JSi90eY4b_45Cn_FM6bzuuadcCjTFkxDXc_45IMeta } from "/vercel/path0/pages/wishlist.vue?macro=true";
import { default as _91id_939fcfMD3LU0gPgPKqS4s5pLYljw3iWVk8kkeTHHzWPc8Meta } from "/vercel/path0/pages/order/[id].vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as toolsyhFKjXdmUPbkLsqiX_v1sV1hBdYUjaIWKVeG3Q23zM8Meta } from "/vercel/path0/pages/admin/tools.vue?macro=true";
import { default as promos0t3fIxpiJkbn3XQT6xrIPlwvCL5EPm3w1uiKBoA5m_454Meta } from "/vercel/path0/pages/admin/promos.vue?macro=true";
import { default as _91id_9389hXx7syO8QVN7nT3iqCRWupA7Gx7C0sjhwJZJedboEMeta } from "/vercel/path0/pages/product/[id].vue?macro=true";
import { default as reportsf9OvZG3_45yvtmqrex95k_OVs14jAE7D8zTUFY1E_45ru30Meta } from "/vercel/path0/pages/admin/reports.vue?macro=true";
import { default as indexsj1gwRqZcN3C8cXW2_45paNxYRwgJKgatcRRSTYCltQUUMeta } from "/vercel/path0/pages/catalog/index.vue?macro=true";
import { default as giftcardsStRc7mhFXq1m63elcEse80ZLnp92ZpSZqjDgD4yHJC8Meta } from "/vercel/path0/pages/admin/giftcards.vue?macro=true";
import { default as welcome10L832v_oSS64FnGCTj6OpSO8TjdItMlyFgcMQq8hJjMEMeta } from "/vercel/path0/pages/admin/welcome10.vue?macro=true";
import { default as indexFs2X1lT2IIf9C6XjdHoLddulZZQ7juvCOVe_45o9I5zpEMeta } from "/vercel/path0/pages/admin/inbox/index.vue?macro=true";
import { default as index8k9t1ngpPsMX77plwyQLECm6e14yAbRkruJLJxIvTUkMeta } from "/vercel/path0/pages/admin/roles/index.vue?macro=true";
import { default as indexDJSiOM_zIwIUYTV50LBdF0mb0VRVUValhYhjRAG39nwMeta } from "/vercel/path0/pages/admin/orders/index.vue?macro=true";
import { default as newz07tIxGY2Hk_TNP0fN6XhrZXIV0fN8aUlFN6docMaRgMeta } from "/vercel/path0/pages/admin/products/new.vue?macro=true";
import { default as editzIveAM196b1oUsAPD_451l_H6zJQcEXvhiwRBVWaMC0d0Meta } from "/vercel/path0/pages/admin/products/edit.vue?macro=true";
import { default as pillowcasesmBIKZBCrcVu8uytZ8tfWzOguu5rzQnn6pGOxQz7SP_458Meta } from "/vercel/path0/pages/catalog/pillowcases.vue?macro=true";
import { default as indexLyxOZ0up2EinpcM7KsatNnzdcBcri9kgNpCbIVtfynoMeta } from "/vercel/path0/pages/admin/products/index.vue?macro=true";
import { default as indexmp1qcmzi9gQxIgcjeyMZm_ZpOQsOLBQG2WGdIsDhF5IMeta } from "/vercel/path0/pages/admin/categories/index.vue?macro=true";
import { default as promo_45exclusionscusDOxD9EyQChDz5_IyeFtPrgdhHxHp9wySeGKuD_eUMeta } from "/vercel/path0/pages/admin/promo-exclusions.vue?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "cart",
    path: "/cart",
    meta: carto17Hk3H3NYEO_45FFdaJOjgwf0g_fC_a17YdUdJaFSiRYMeta || {},
    component: () => import("/vercel/path0/pages/cart.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: logouta5LfroDscl83QSOVnBg1WHUyENO_v5V_454taSGE0odUIMeta || {},
    component: () => import("/vercel/path0/pages/logout.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/vercel/path0/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: { ...(profileFId_45d62DZvDfSRqu_45gOkgT1Y2dyc04X7CB8OOqCLklMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/pages/profile.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    meta: { ...(checkoutCVHKVPUd1E_45TOH8c9_4542gIRCznC3qyQFx_45Zk6UX36UgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/pages/checkout.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/vercel/path0/pages/contacts.vue")
  },
  {
    name: "delivery",
    path: "/delivery",
    component: () => import("/vercel/path0/pages/delivery.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: {"middleware":"guest"},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "wishlist",
    path: "/wishlist",
    component: () => import("/vercel/path0/pages/wishlist.vue")
  },
  {
    name: "order-id",
    path: "/order/:id()",
    component: () => import("/vercel/path0/pages/order/[id].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "admin-tools",
    path: "/admin/tools",
    meta: { ...(toolsyhFKjXdmUPbkLsqiX_v1sV1hBdYUjaIWKVeG3Q23zM8Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/tools.vue")
  },
  {
    name: "admin-promos",
    path: "/admin/promos",
    meta: { ...(promos0t3fIxpiJkbn3XQT6xrIPlwvCL5EPm3w1uiKBoA5m_454Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/promos.vue")
  },
  {
    name: "product-id",
    path: "/product/:id()",
    meta: _91id_9389hXx7syO8QVN7nT3iqCRWupA7Gx7C0sjhwJZJedboEMeta || {},
    component: () => import("/vercel/path0/pages/product/[id].vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    component: () => import("/vercel/path0/pages/admin/reports.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/vercel/path0/pages/catalog/index.vue")
  },
  {
    name: "admin-giftcards",
    path: "/admin/giftcards",
    meta: { ...(giftcardsStRc7mhFXq1m63elcEse80ZLnp92ZpSZqjDgD4yHJC8Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/giftcards.vue")
  },
  {
    name: "admin-welcome10",
    path: "/admin/welcome10",
    meta: { ...(welcome10L832v_oSS64FnGCTj6OpSO8TjdItMlyFgcMQq8hJjMEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/welcome10.vue")
  },
  {
    name: "admin-inbox",
    path: "/admin/inbox",
    meta: { ...(indexFs2X1lT2IIf9C6XjdHoLddulZZQ7juvCOVe_45o9I5zpEMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/inbox/index.vue")
  },
  {
    name: "admin-roles",
    path: "/admin/roles",
    meta: { ...(index8k9t1ngpPsMX77plwyQLECm6e14yAbRkruJLJxIvTUkMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/roles/index.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: { ...(indexDJSiOM_zIwIUYTV50LBdF0mb0VRVUValhYhjRAG39nwMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/orders/index.vue")
  },
  {
    name: "admin-products-new",
    path: "/admin/products/new",
    meta: { ...(newz07tIxGY2Hk_TNP0fN6XhrZXIV0fN8aUlFN6docMaRgMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/products/new.vue")
  },
  {
    name: "admin-products-edit",
    path: "/admin/products/edit",
    meta: { ...(editzIveAM196b1oUsAPD_451l_H6zJQcEXvhiwRBVWaMC0d0Meta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/products/edit.vue")
  },
  {
    name: "catalog-pillowcases",
    path: "/catalog/pillowcases",
    meta: pillowcasesmBIKZBCrcVu8uytZ8tfWzOguu5rzQnn6pGOxQz7SP_458Meta || {},
    component: () => import("/vercel/path0/pages/catalog/pillowcases.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    meta: { ...(indexLyxOZ0up2EinpcM7KsatNnzdcBcri9kgNpCbIVtfynoMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/products/index.vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: { ...(indexmp1qcmzi9gQxIgcjeyMZm_ZpOQsOLBQG2WGdIsDhF5IMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/categories/index.vue")
  },
  {
    name: "admin-promo-exclusions",
    path: "/admin/promo-exclusions",
    meta: { ...(promo_45exclusionscusDOxD9EyQChDz5_IyeFtPrgdhHxHp9wySeGKuD_eUMeta || {}), ...{"middleware":["auth","admin"]} },
    component: () => import("/vercel/path0/pages/admin/promo-exclusions.vue")
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/catalog/hair-scrunchies",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/catalog/turbans",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  },
  {
    name: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYEMeta?.name,
    path: "/catalog/pizhamy",
    component: component_45stuboAz8_45A0Kn4UDy3_45mbrx41goFO1bmmVjE5gsRC5joJYE
  }
]